// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Contact_Wrapper__3dlEy","Contact":"Contact_Contact__1mx-H","Form":"Contact_Form__1NC4t","Button":"Contact_Button__SPC6k","Background":"Contact_Background__EOIAP"};